import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Dumbbell, Calendar, TrendingUp, Library } from 'lucide-react';

function BottomTabBar() {
  const location = useLocation();

  const tabs = [
    { to: '/', icon: Dumbbell, label: 'Today' },
    { to: '/week', icon: Calendar, label: 'Week' },
    { to: '/history', icon: TrendingUp, label: 'Progress' },
    { to: '/library', icon: Library, label: 'Library' },
  ];

  return (
    <nav className="gymbo-tabbar fixed bottom-0 left-0 right-0 bg-light-surface dark:bg-dark-surface border-t border-light-border dark:border-dark-border pb-[26px] safe-area-bottom">
      <div className="flex items-stretch justify-around">
        {tabs.map(({ to, icon: Icon, label }) => {
          const isActive = location.pathname === to;
          return (
            <Link
              key={to}
              to={to}
              className="flex flex-col items-center justify-center flex-1 pt-2 pb-1 min-h-[44px]"
            >
              <Icon
                size={24}
                className={
                  isActive
                    ? 'text-light-accent dark:text-dark-accent'
                    : 'text-light-faint dark:text-dark-faint'
                }
                strokeWidth={2}
              />
              <span
                className={`mt-1 text-[11px] font-plex font-medium ${
                  isActive
                    ? 'text-light-accent dark:text-dark-accent'
                    : 'text-light-faint dark:text-dark-faint'
                }`}
              >
                {label}
              </span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}

export default BottomTabBar;
